import { render, staticRenderFns } from "./specification.vue?vue&type=template&id=8f930e9a&scoped=true&"
import script from "./specification.vue?vue&type=script&lang=js&"
export * from "./specification.vue?vue&type=script&lang=js&"
import style0 from "./specification.vue?vue&type=style&index=0&id=8f930e9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f930e9a",
  null
  
)

export default component.exports